import { render, staticRenderFns } from "./compatibility.view.vue?vue&type=template&id=8708510a&"
import script from "./compatibility.view.vue?vue&type=script&lang=ts&"
export * from "./compatibility.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports